import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {UploapFileExpedienteComponent} from '../sub-components/upload-file-expediente/uploap-file-expediente.component';
import {MatDialog} from '@angular/material/dialog';
import {MessageCrudService} from '@evomatik/evk-common';
import {PrestacionModel} from '../../models/prestacion.model';
import {DetallePrestacionComponent} from '../sub-components/detalle-prestacion/detalle-prestacion.component';
import {PrestacionSocialService} from '../../services/prestacion-social.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSelectChange} from '@angular/material/select';
import { EvkMapasService } from '../../../wizard/componentes/section/sub-components/evk-mapas/evk-mapas.service';

@Component({
    selector: 'lib-prestacion-social-page',
    templateUrl: './prestacion-social-page.component.html',
    styleUrls: ['./prestacion-social-page.component.scss'],
    providers: [PrestacionSocialService],
    encapsulation: ViewEncapsulation.None
})
export class PrestacionSocialPageComponent implements OnInit {

    @Input()
    titulo = 'MiTCh';

    @Input()
    subTitulo = 'Mi Trámite Chihuahua';

    @Input()
    canImport = true;

    @ViewChild(MatPaginator, {static: true})
    paginator: MatPaginator;

    dataSource: MatTableDataSource<any>;

    columns = [];

    filtroSeleccionado: String;

    valoresFiltros = {};

    filters = [
        {
            id: 'folio',
            title: 'Número de folio',
            path: 'expediente.folioProvisional',
        },
        {
            id: 'fechaDeCreacion',
            title: 'Fecha de creación',
            path: 'fechaDeCreacion',
        },
        {
            id: 'nombre',
            title: 'Nombre ó Institución',
            path: 'datosPrograma.a4NombrePrograma.value',
        }
    ];
    public pageIndex = 0;

    public pageSize = 10;

    public pageSizeOptions = [5, 10, 25, 100];

    public totalItems = 0;

    public pageFilter = '';

    public pageOrder = '';

    load: boolean;

    constructor(
        public dialog: MatDialog,
        public messageCrudService: MessageCrudService,
        public prestacionService: PrestacionSocialService,
    ) {
        this.columns = ['folio', 'fechaCreacion', 'tipoBeneficiario', 'nombre', 'nombrePrograma', 'acciones'];
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource([]);
        this.pageOrder = 'expediente.created';
        this.loadPage();
    }

    onFiltroChange($event: MatSelectChange) {
        if ($event.value) {
            this.filtroSeleccionado = $event.value;
        }
        if (!$event.value) {
            this.filtroSeleccionado = null;
            this.valoresFiltros = {};
            this.prestacionService.deleteAllFilter();
            this.loadPage();
        }
    }

    getNombre(row){
        // console.log(row)
        if(row?.datosTipoBeneficiario?.a4TipoBeneficiario?.value === "1"){
            return `${row?.datosTipoBeneficiario?.a4NombreBeneficiario? row?.datosTipoBeneficiario?.a4NombreBeneficiario : ''} ${row?.datosTipoBeneficiario?.a4PrimerApellidoBeneficiario? row?.datosTipoBeneficiario?.a4PrimerApellidoBeneficiario : ''} ${row?.datosTipoBeneficiario?.a4SegundoApellidoBeneficiario? row?.datosTipoBeneficiario?.a4SegundoApellidoBeneficiario : ''}`;
        } else {
            return `${row?.datosTipoBeneficiarioInstitucion?.a4NombreInstitucion? row?.datosTipoBeneficiarioInstitucion?.a4NombreInstitucion : ''}`;
        }
    }
    getTipoBeneficiario(row){
        // console.log(row)
        if(row?.datosTipoBeneficiario?.a4TipoBeneficiario?.value === "1"){
            return row?.datosTipoBeneficiario?.a4TipoBeneficiario?.label;
        } else {
            return row?.datosTipoBeneficiarioInstitucion?.a4TipoBeneficiario?.label;
        }
    }

    filterBy() {
        this.prestacionService.deleteAllFilter();
        const key = this.filtroSeleccionado ? this.filtroSeleccionado.toString() : null;
        if (key) {
            const filter = this.filters.find((item) => item.id === key);
            const value = this.valoresFiltros[key];
            this.prestacionService.addFilter(filter.path, value);
            this.load = false;
            this.loadPage();
        }
    }

    onDateInputed($event: any) {
        const dateString = $event.target.value;
        const parts = dateString.split('/');
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        this.valoresFiltros['fechaDeCreacion'] = new Date(year, month - 1, day);

    }

    traduccionPaginador() {
        this.paginator._intl.itemsPerPageLabel = 'Registros por página';
        this.paginator._intl.nextPageLabel = 'Siguiente página';
        this.paginator._intl.previousPageLabel = 'Página anterior';
        this.paginator._intl.firstPageLabel = 'Primera página';
        this.paginator._intl.lastPageLabel = 'Ultima página';
    }

    loadPage(page?: any): void {
        this.dataSource.data = [];
        if (page?.pageSize && page?.pageSize !== this.pageSize) {
            this.pageIndex = 0;
            this.pageSize = page.pageSize;
        }

        const pageToLoad: number = page && page.pageSize !== undefined ? page.pageIndex : this.pageIndex ? this.pageIndex : 0;

        this.prestacionService.getPrestaciones({
                pageNumber: pageToLoad,
                pageSize: this.pageSize,
                orderBy: this.pageOrder
            }
        ).subscribe({
            next: (response: any) => {
                this.onSuccess(response, pageToLoad)
            }, error: () => {
                this.onError();
            }
        })
    }

    registrarNuevoExcel() {
        const dialogDocumentos = this.dialog.open(UploapFileExpedienteComponent, {
            disableClose: true,
            data: {}
        });
        dialogDocumentos.afterClosed().subscribe(response => {
            this.loadPage();
            if (response != null && response) {
            }
        });
    }

    detailPrestacion(row: PrestacionModel) {
        this.dialog.open(DetallePrestacionComponent, {
            disableClose: true,
            data: {
                value: row,
                readOnly: true
            }
        });
    }

    updatePrestacion(row: PrestacionModel) {
        const update = this.dialog.open(DetallePrestacionComponent, {
            disableClose: true,
            data: {
                value: row,
                readOnly: false
            }
        });
        update.afterClosed().subscribe(response => {
            if (response != null && response) {
                this.loadPage();
            }
        });
    }

    public changePageHandler(event: PageEvent) {
        this.loadPage(event);
    }

    protected onSuccess(data: Response | null, page: number): void {
        this.totalItems = data.totalResult;
        this.pageIndex = page;
        this.dataSource.data = data?.prestacionesSociales || [];
        this.load = true;
    }

    protected onError(): void {
        this.pageIndex = 0;
        this.dataSource.data = [];
        this.load = true;
    }

}

interface Response {
    prestacionesSociales: PrestacionModel[];
    totalPages?: number;
    totalResult: number;
}
